class ProductContextTabs extends HTMLElement {
  constructor() {
    super();

    /** @type {HTMLElement[]} */
    this.tabs = [];
    /** @type {HTMLElement[]} */
    this.panels = [];
  }

  connectedCallback() {
    this.tabs = /** @type {HTMLElement[]} */ (Array.from(this.querySelectorAll('[role="tab"]')));
    this.panels = /** @type {HTMLElement[]} */ (Array.from(this.querySelectorAll('[role="tabpanel"]')));

    if (this.tabs.length < 2) return;

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.selectTab(tab));
      tab.addEventListener('keydown', (event) => this.onKeyDown(/** @type {KeyboardEvent} */ (event)));
    });
  }

  /**
   * @param {HTMLElement} selectedTab
   */
  selectTab(selectedTab) {
    this.tabs.forEach((tab) => {
      const isSelected = tab === selectedTab;
      const panel = /** @type {HTMLElement | null} */ (this.querySelector(`#${tab.getAttribute('aria-controls')}`));

      tab.setAttribute('aria-selected', String(isSelected));
      tab.tabIndex = isSelected ? 0 : -1;

      if (panel) {
        panel.hidden = !isSelected;
      }
    });
  }

  /**
   * @param {KeyboardEvent} event
   */
  onKeyDown(event) {
    if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;

    event.preventDefault();

    const currentTab = /** @type {HTMLElement | null} */ (event.currentTarget);
    if (!currentTab) return;

    const currentIndex = this.tabs.indexOf(currentTab);
    if (currentIndex < 0) return;

    let nextIndex = currentIndex;

    if (event.key === 'ArrowRight') {
      nextIndex = (currentIndex + 1) % this.tabs.length;
    } else if (event.key === 'ArrowLeft') {
      nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
    } else if (event.key === 'Home') {
      nextIndex = 0;
    } else if (event.key === 'End') {
      nextIndex = this.tabs.length - 1;
    }

    const nextTab = this.tabs[nextIndex];
    if (!nextTab) return;

    nextTab.focus();
    this.selectTab(nextTab);
  }
}

if (!customElements.get('product-context-tabs')) {
  customElements.define('product-context-tabs', ProductContextTabs);
}
